module.exports = __webpack_public_path__ + "static/media/eu.ee7f4712.svg";